var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col min-h-screen bg-white",attrs:{"id":"app"}},[_c('MyHeader'),_c('div',{staticClass:"flex-grow mx-8 sm:mx-0"},[_c('router-view',{})],1),_c('MyFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }